<template>
  <div :class="row ? 'select-row' : 'select'" :style="{'width':width}">
    <SearchBox :labeltxt="labeltxt" :row="row">
      <v-tooltip top v-if="tooltip && selectionLabel != null">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <!-- Component Start -->
            <v-combobox
              ref="myComboBox"
              outlined
              rounded
              dense
              :height="height"
              hide-details="auto"
              @change="onchange"
              :placeholder="placeholder"
              :items="items"
              :value="value"
              :item-text="itemText"
              :item-value="itemValue"
              :item-disabled="itemDisabled"
              :return-object="true"
              :error-messages="errorsMsg"
              :clearable="clearable"
              :labeltxt="labeltxt"
              :disabled="disabled">
            <template v-slot:selection>
              <span class="combobox_selection">{{selectionLabel}}</span>
            </template>
            </v-combobox>
            <!-- Component End -->
          </div>
        </template>
        <span>{{selectionLabel}}</span>
      </v-tooltip>
      <!-- Component Start -->
      <v-combobox
        v-else
        ref="myComboBox"
        outlined
        rounded
        dense
        :height="height"
        hide-details="auto"
        @change="onchange"
        :placeholder="placeholder"
        :items="items"
        :value="value"
        :item-text="itemText"
        :item-value="itemValue"
        :item-disabled="itemDisabled"
        :return-object="true"
        :error-messages="errorsMsg"
        :clearable="clearable"
        :labeltxt="labeltxt"
        :disabled="disabled">
       <template v-slot:selection>
        <span class="combobox_selection">{{selectionLabel}}</span>
       </template>
      </v-combobox>
      <!-- Component End -->
    </SearchBox>
  </div>
</template>

<script>
export default {
  name: 'DefaultCombobox',
  props: {
    items: {
      type: [Array],
    },
    itemText: {
      type: [String, Array],
      default() {
        return 'label';
      },
    },
    itemValue: {
      type: [String, Number, Object, Array],
      default() {
        return 'value';
      },
    },
    itemDisabled: {
      type: [String, Array],
    },
    height: {
      type: [String],
      default() {
        return '32px';
      },
    },
    placeholder: {
      type: [String],
      default() {
        return '請選擇';
      },
    },
    labeltxt: {
      type: [String],
      default() {
        return null;
      },
    },
    value: {
      type: [String, Number, Object],
    },
    returnObject: {
      type: [Boolean],
      default: false,
    },
    selectIndex: {
      type: [Number],
    },
    errorsMsg: {
      type: [String, Array],
    },
    clearable: {
      type: [Boolean],
      default: false,
    },
    disabled: {
      type: [Boolean],
    },
    row: {
      type: [Boolean],
      default: false,
    },
    width: {
      type: String,
    },
    tooltip: {
      type: [Boolean],
      default: true,
    },
  },
  data() {
    return {
      selectionLabel: null,
    };
  },
  watch: {
    items() {
      this.selectionLabel = this.label();
    },
  },
  methods: {
    onchange(val) {
      if (typeof val === 'string' || val === null) {
        this.selectionLabel = null;
        this.$emit('input', null);
        this.$refs.myComboBox.internalSearch = null;
        this.$refs.myComboBox.reset();
      } else {
        this.selectionLabel = val.label;
        this.$emit('input', val.value);
      }
    },
    label() {
      if (Array.isArray(this.items) === true) {
        const item = this.items.find((x) => x.value === this.value);
        return item === undefined || item.label === undefined ? null : item.label;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 160px;
  display: inline-block;
}

.select-row {
  width: 320px;
}
::v-deep.v-text-field.v-select .v-input__control .v-input__slot {
  input {
    cursor: pointer;
    line-height: initial;
  }
  cursor: pointer;
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px;
  background-color: $white;
  .v-input__append-inner {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .v-select__selection {
    max-width: 90%;
    @include pad-width() {
      max-width: 90%;
    }
  }
  .v-select__slot .v-select__selections
  {
    display: flex;
    flex-wrap: nowrap;
  }
}

::v-deep.v-list .v-list-item .v-list-item__content {
  .v-list-item__title {
    overflow: unset;
    text-overflow: unset;
    white-space: unset;
  }
}

.combobox_selection {
  overflow: hidden;
  white-space: nowrap; /* Don't forget this one */
  text-overflow: ellipsis;
}

</style>
